<template>
  <div class="animated fadeInUp" id="dashboard">
    <div class="section">
      <h3 class="text-bold">Settlements</h3>
      <div class="has-text-centered">
          <div class="has-text-centered">
            <div class="pt-20 pb-50">
              <div class="z-index-2">

                <div class="hr-content">
                  <!-- search bar -->
                  <p class="text-left">
                    <router-link to="/vendor-settlements" class="text-hard-bold text-dark" active-class="current">Settlement Page</router-link>
                    <i class="fas fa-chevron-right mx-4"></i> 
                    Settlement Details
                  </p>

                  <div class="row mb-5">
                    <div class="col-12 col-lg-8">
                      <div class="rounded bg-light shadow">
                        <div class="xrow p-3">
                          <div class="row">
                            <div class="col-6 text-left mb-4">
                              <p class="text-hard-bold mb-0">Status</p>
                              <p class="mb-0 mt-3">
                                <status-button :status="'paid'" />
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-4 text-left mb-4">
                              <span class="text-hard-bold">Date</span>
                              <p class="mb-0 mt-3">{{ new Date(currentSettlement.created_at) | dateFormat('DD/MM/YYYY') }}
                                <br> {{ new Date(currentSettlement.created_at) | dateFormat('h:mm a') }}</p>
                            </div>
                            <div class="col-4 text-left">
                              <span class="text-hard-bold">Settlement ID</span>
                              <p class="mb-0 mt-3">{{ currentSettlement.short_id }}</p>
                            </div>
                            <div class="col-4 text-left">
                              <span class="text-hard-bold">Amount</span>
                              <p class="mb-0 mt-3">GHS {{ currentSettlement.settlement_amount | currency }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="px-3">
                    <div class="row text-left">
                      <div class="col-9 pl-0">
                        <h2>Transactions</h2>
                      </div>

                      <div class="col-3 pr-0 d-none d-md-inline-table">
                        <button data-v-5c297eaf="" type="button" class="btn w-100 rounded-pills mr-1 btn-primary" @click="doExport">Export Transactions</button>
                      </div>
                    </div>

                    <table-filters 
                      :hidePayers="true"
                      @filtersSubmit="filtersSubmit"
                      @reset="clear"
                    />
                  </div>

                  <b-table 
                    class="d-none d-md-inline-table"
                    ref="table"
                    id="my-table" 
                    hover 
                    head-variant="dark"
                    :items="currentTransactionForSettlement" 
                    :fields="masterTableProps.fields" 
                    :per-page="masterTableProps.resultsPerPage"
                    :current-page="masterTableProps.currentPage"
                    :filter="filter"
                    :filter-function="filterTable"
                    :sort-by.sync="masterTableProps.sortBy"
                    :sort-desc.sync="masterTableProps.sortDesc"
                    :sort-direction="masterTableProps.sortDirection"
                    show-empty
                    @filtered="onFiltered"
                    :busy="currentTransactionIsReady"
                  >
                    <template #empty>
                      <empty-table></empty-table>
                    </template>
                    <template #table-busy>
                        <div style="display:flex; justify-content: center">
                          <spinner></spinner>
                        </div>
                      </template>
                    <template #cell(created_at)="data">
                      {{ new Date(data.item.created_at) | dateFormat('DD/MM/YYYY h:mm A') }}
                    </template>
                    <!-- <template #cell(service_reference)="data">
                      <a class="text-link">{{ data.item.service_reference }}</a>
                    </template> -->
                    <template #cell(transaction_amount)="data">
                      {{ data.item.currency }} {{ data.item.transaction_amount | currency }}
                    </template>
                  </b-table>
                  <mobile-transaction
                    :transactions="currentTransactionForSettlement"
                    :loading="currentTransactionIsReady"
                    :limit="10"
                    :hasRoute="false"
                    :search="search"
                    :filter="filter_mobile"
                  />

                  <table-pagination
                      :totalRows="rows"
                      @paginationChange="handlePaginationChange"
                  />
                </div>
              </div>
            </div>
          </div>
      </div>
      <FooterSpacing></FooterSpacing>
    </div>
  </div>
</template>
<script>
import store from '../store';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import EmptyTable from '../utils/empty-table.vue';
import MobileTransaction from '../components/MobileTransaction.vue';
import FooterSpacing from '../components/FooterMobile.vue';
import StatusButton from '../components/StatusButton.vue';
import TableFilters from '../components/TableFilters.vue';
import TransactionAPI from '../api/transactions_api';
import TablePagination from '../components//TablePagination.vue';

export default {
  mixins: [
    tableMixin
  ],
  components: {
    spinner,
    EmptyTable,
    MobileTransaction,
    FooterSpacing,
    StatusButton,
    TableFilters,
    TablePagination
  },
  data() {
    return {
      filter_mobile: {},
      search: '',
      authenticated: '',
      headerTag: {
        'animated fadeIn': false,
        hidden: true,
      },
      loggedInUser: {},
      filterTerm: '',
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date'
          },
          {
            key: 'service_type.name',
            sortable: false,
            label: 'Type'
          },
          {
            key: 'service_reference',
            sortable: true,
            label: 'Number'
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID'
          },
          {
            key: 'payer_account.name',
            sortable: true,
            label: 'Payer'
          },
          {
            key: 'transaction_amount',
            sortable: false,
            label: 'Amount'
          }
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'desc',
        totalRows: 1,
        sortDesc: true
      },
    };
  },
  methods: {
    handlePaginationChange(page_number) {
      const params = {
        ...this.filterProperties,
        page: page_number
      };
      this.getSettlementTransactions(params);
    },
    filtersSubmit (params) {  
      this.getSettlementTransactions(params);
    },
    clear: function() {
      store.dispatch('resetFilterProperties');
      this.getSettlementTransactions();
    },
    getSettlementTransactions: function(params) {
      const id = this.$route.params.id;

      if (id) {
        TransactionAPI.methods.getSettlementTransactions(id, params)
        .then(verResponse => {})
        .catch(error => {
            console.log('error', error);
        });
      } else {
        console.log('no id');
      }
    },
    doExport () {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      const accountId = userContext.user.id;
      const settlementId = this.$route.params.id;
      const params = this.serialize(this.filterProperties);
      console.log('params', params);

      window.location = 'https://jetpay-api.herokuapp.com/api/v1/payments/export/settlement/' + settlementId + '/transactions' + '?' + params;;
    },
    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p) && obj[p] && obj[p] != 'null') {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
  },
  computed: {
    filterProperties: {
      get: function () {
        return store.state.filterProperties;
      },
      set: function (newValue) {
        store.state.filterProperties = newValue;
      }
    },
    currentTransactionIsReady () {
      if (this.axiosRequestAmount == 0) {
        return false
      }

      return true
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      }
    },
    rows() {
      return store.state.currentTransactionForSettlement.count;
    },
    payersListing: {
      // TODO: generate payer listing from currentTransaction data
      get: function () {
        return store.state.payersListing;
      },
      set: function (newValue) {
        store.state.payersListing = newValue;
      }
    },
    currentTransactionForSettlement: {
      get: function () {
        return store.state.currentTransactionForSettlement.results;
      },
      set: function (newValue) {
        store.state.currentTransactionForSettlement.results = newValue;
      }
    },
    payerList: function() {
      return this.payersListing;
    },
    currentSettlement: {
      get: function () {
        return store.state.currentSettlement;
      },
      set: function (newValue) {
        store.state.currentSettlement = newValue;
      }
    }
  },
};
</script>
<style>
@import '../assets/css/table.css';

.rounded-pills {
  border-radius: 30px;
}
.pagination {
    float: left;
}
.pagination li {
  display: inline-block;
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
</style>
